module.exports = __webpack_public_path__ + "img/score-ar.8ac0acc7.png";